export default __webpack_public_path__ + "static/tools-bg1-03cbc59d7eb785ff3561b8e42fd7897f.svg";